import { render, staticRenderFns } from "./SafType.vue?vue&type=template&id=606daa2b&"
import script from "./SafType.vue?vue&type=script&lang=js&"
export * from "./SafType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports